import Vue from 'vue'
import ContactsSection from './ContactsSection/ContactsSection.vue'
import InfoSection from './InfoSection/InfoSection.vue'
import Channel from '@/models-ts/user/Channel'
import FullTimeInfo from '@/models-ts/user/profiles/freelancer/FullTimeInfo'
import MyFreelancerProfile from '@/models-ts/user/profiles/freelancer/MyFreelancerProfile'

export default Vue.extend<any, any, any, any>({
  components: {
    InfoSection,
    ContactsSection,
  },
  props: {
    profile: MyFreelancerProfile,
  },
  data() {
    return {}
  },
  methods: {
    onFulltimeInfoUpdate(info: FullTimeInfo) {
      this.$emit('update', new MyFreelancerProfile({ ...this.profile, fulltimeInfo: info }))
    },
    onChannelsUpdate(ch: Array<Channel>) {
      this.$emit(
        'update',
        new MyFreelancerProfile({
          ...this.profile,
          channels: ch,
        })
      )
    },
  },
})
